import React from 'react'
import {useSelector, useDispatch} from "react-redux";
import { Pie } from 'react-chartjs-2'
import 'chartjs-plugin-labels'
import {Link} from 'react-router-dom'

import Modal from 'react-bootstrap/Modal'

import DraggableModalDialog from "../DraggableModalDialog/DraggableModalDialog"
import {
	toggleExpandedData
} from '../../state/events'

const ExpandedData =() =>{
	let dispatch = useDispatch();
	const W = window.innerWidth
	const eventData = useSelector((state)=>state.allEvents.expandedData)
	return (
		<Modal 
			animation={false}
			dialogAs={DraggableModalDialog} 
			show={eventData.show} 
			onHide={()=>dispatch(toggleExpandedData())} 
			centered>
			<Modal.Header closeButton>
				<Modal.Title>{eventData.clientName}'s {eventData.title} stats</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Pie 
					data={{
						labels:['Complete','Open','Not Met'],
						datasets:[{
							backgroundColor:['#3fd953','#4160e8','#e85241'],
							data:[
								parseInt(eventData.complete),
								parseInt(eventData.open),
								parseInt(eventData.notMet)
							]
						}]
					}}
					options={{
						//no need for tooltips
						tooltips:{
							enabled:false
						},
						//no need for color hover change
						hover:{mode:null},
						plugins:{
							labels:[
								{
									render:'percentage',
									position:'border',
									fontColor:'#fff',
									textMargin:4,
									fontSize:16
								},{
									render:'value',
									fontColor:'#fff',
									fontSize:16
								}
							]
						}
					}}
					height={W < 600 ? 300 : 200}
					/>
				<div className="mb-1 text-center">
					<small className="text-secondary">
						<i className="fas fa-info-circle"></i> Hint: Click on complete/open/not met to toggle data
					</small>
				</div>
				<Link
					className="d-block text-center mt-2" 
					onTouchEnd={e=>{
						e.stopPropagation()
						window.location = eventData.location
					}} 
					to={eventData.location}>Click to view all {eventData.linkText}</Link>
			</Modal.Body>
		</Modal>
	)
}
export default ExpandedData